<template lang='pug'>
v-card(width='480' class='confirm-update-onedrive-dialog')
    div.pt-10.pb-6
        v-card-title.d-flex.align-center.flex-column.justify-center.pa-0
            v-icon(size='70' color='orange') icon-chat

        v-card-text.pt-4.px-10.text-center
            span(
                class='confirm-message'
                style='font-family: "Noto Sans TC"; font-size: 16px; font-weight: 500; color: #535353; letter-spacing: 0.5px; line-height: 150%;'
            ) {{ $t('DOCUMENT_AGENT_PROPERTY.CONFIRM_UPDATE_TO_ONEDRIVE') }}

    v-card-actions.px-6.py-4.justify-end(style='background-color: #F8F9FA; border-top: 1px solid #E8E8E8;')
        v-btn.mr-2(
            @click='onCancel'
            width='100px'
            height='40'
            outlined
            color='#666666'
            style='border: 1px solid #888888; border-radius: 4px; background-color: white;'
            :ripple='false'
        )
            span(style="font-family: 'Segoe UI'; font-weight: 600; font-size: 16px; letter-spacing: 0.5px; color: #666666;") {{ $t('PORTAL.DONT_DELETE') }}
        v-btn(
            @click='onConfirm'
            width='100px'
            height='40'
            color='#14C6DE'
            style='border-radius: 4px;'
            :ripple='false'
            depressed
        )
            span(style="font-family: 'Segoe UI'; font-weight: 600; font-size: 16px; letter-spacing: 0.5px; color: #FFFFFF;") {{ $t('PORTAL.CONFIRM_UPDATE') }}
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    methods: {
        onCancel() {
            this.$emit('cancel');
        },
        onConfirm() {
            this.$emit('confirm');
        },
    },
});
</script>

<style scoped lang="css">
.confirm-update-onedrive-dialog {
    border-radius: 8px !important;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2) !important;
}
.confirm-message {
    line-height: 1.6;
}
</style>
